import abTests from 'frontend/shared/javascripts/modules/ab_tests'
import { syncExperimentAssignments } from 'frontend/shared/javascripts/modules/experiment_assignment_sync'
import { on } from 'shared/javascripts/util/events'

abTests.boot()

syncExperimentAssignments()

on('app:session:synced', () => syncExperimentAssignments())

on('convert:experiences:updated', () => {
  const experienceData = window.convert?.currentData?.experiences ?? {}

  for (const attribute of [...document.documentElement.attributes]) {
    if (attribute.name.startsWith('data-convert-')) {
      document.documentElement.removeAttribute(attribute.name)
    }
  }

  for (const [experimentId, experience] of Object.entries(experienceData)) {
    const variationId = experience?.variation?.id
    if (variationId == null) continue

    document.documentElement.setAttribute(`data-convert-${experimentId}`, String(variationId))
  }

  syncExperimentAssignments()
})
